import React, { useState } from "react";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PhoneCodeFiled from "../DriverSignup/phone";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { postApihandler } from "../../ApiHandler";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import "../../CSS/UserLogin/index.css";
import "../../CSS/UserSignup/modern.css";

const UserSignup = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { handleSubmit } = useForm();

  const sendOtp = async () => {
    const res = await postApihandler("/verifyEmail", { email });
    if (res.status === 200) {
      swal({
        icon: "success",
        text: "Otp successfully sent to your email",
      });
      history("/otp");
    }
  };

  const submitSignup = async () => {
    if (!agreedToTerms) {
      swal({
        icon: "warning",
        text: "Please agree to the Terms & Conditions",
      });
      return;
    }
    setIsSubmitting(true);
    try {
      const signupData = {
        fullName,
        email,
        countryCode,
        phoneNumber: mobileNumber,
        password,
      };
      const postRes = await postApihandler("/addUser", signupData);
      if (postRes.status === 200) {
        localStorage.setItem("Email", postRes.data.data.email);
        await sendOtp();
      } else {
        swal({
          icon: "error",
          title: postRes.error.response.data.message,
          text: "Please Try Again",
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <AdminLayout>
      <div className="user-login-wrapper">
        <section className="user-login-page">
          <div className="user-login-hero">
            <span className="user-login-blob user-login-blob--1" aria-hidden="true" />
            <span className="user-login-blob user-login-blob--2" aria-hidden="true" />
            <span className="user-login-blob user-login-blob--3" aria-hidden="true" />
            <div className="user-login-hero-content">
              <span className="user-login-hero-badge">
                <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} />
                Comfort Trip
              </span>
              <h2 className="user-login-hero-title">Join Comfort Trip</h2>
              <p className="user-login-hero-subtitle">
                Create your account and book personal drivers with luxury service in minutes.
              </p>
            </div>
          </div>

          <div className="user-login-panel">
            <div className="user-login-card user-signup-card">
              <header className="user-login-card-header">
                <h1 className="user-login-card-title">{t("page_title_userSignup")}</h1>
                <p className="user-login-card-subtitle">
                  Fill in your details to get started
                </p>
              </header>

              <form
                className="user-login-form user-signup-form"
                noValidate
                onSubmit={handleSubmit(submitSignup)}
              >
                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="signup-fullname">
                    {t("form_fullName_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <PersonOutlineIcon className="user-login-input-icon" />
                    <input
                      id="signup-fullname"
                      className="user-login-input"
                      type="text"
                      placeholder={t("form_fullName_text")}
                      required
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="signup-email">
                    {t("form_email_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <EmailOutlinedIcon className="user-login-input-icon" />
                    <input
                      id="signup-email"
                      className="user-login-input"
                      type="email"
                      placeholder={t("form_email_text")}
                      autoComplete="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="signup-mobile">
                    {t("form_mobile_text")}
                  </label>
                  <div className="user-signup-phone-row">
                    <div className="user-signup-phone-code">
                      <PhoneCodeFiled setCountryCode={setCountryCode} />
                    </div>
                    <div className="user-login-input-wrap user-signup-phone-input">
                      <PhoneOutlinedIcon className="user-login-input-icon" />
                      <input
                        id="signup-mobile"
                        className="user-login-input"
                        type="tel"
                        placeholder={t("form_mobile_text")}
                        autoComplete="tel"
                        required
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="signup-password">
                    {t("form_password_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <LockOutlinedIcon className="user-login-input-icon" />
                    <input
                      id="signup-password"
                      className="user-login-input user-login-input--password"
                      type={showPassword ? "text" : "password"}
                      placeholder={t("form_password_text")}
                      autoComplete="new-password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="user-login-toggle-password"
                      onClick={togglePasswordVisibility}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      {showPassword ? (
                        <VisibilityOffOutlinedIcon fontSize="small" />
                      ) : (
                        <VisibilityOutlinedIcon fontSize="small" />
                      )}
                    </button>
                  </div>
                </div>

                <div className="user-signup-terms">
                  <input
                    id="signup-terms"
                    type="checkbox"
                    checked={agreedToTerms}
                    onChange={(e) => setAgreedToTerms(e.target.checked)}
                    required
                  />
                  <label htmlFor="signup-terms">{t("form_terms_text")}</label>
                </div>

                <button
                  type="submit"
                  className="user-login-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting && <span className="user-login-submit-spinner" />}
                  {t("form_signupBtn_text")}
                </button>
              </form>

              <footer className="user-login-footer">
                <p>
                  {t("form_have_account_text")}
                  <Link to="/user-login">{t("form_loginBtn_text")}</Link>
                </p>
              </footer>
            </div>
          </div>
        </section>
      </div>

      <section className="user-signup-promo">
        <div className="user-signup-promo-inner">
          <div className="user-signup-promo-content">
            <h2 className="user-signup-promo-title">
              {t("user_signup_section_title1")}
            </h2>
            <p>{t("user_signup_section_para1")}</p>
            <p>{t("user_signup_section_para2")}</p>
            <button type="button" className="user-signup-promo-btn">
              {t("user_signup_book_driverNow")}
            </button>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default UserSignup;
